import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { UserDto } from '@interfaces/UserDto';
import { EstimateSettingsService } from '@shared/services/estimate-settings.service';
import { LicenseAppModule, LicenseService } from '@shared/services/license.service';
import { LoadingService } from '@shared/services/loading.service';
import { UserService } from '@shared/services/user.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'pop-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.less']
})
export class LandingPageComponent extends BaseComponent implements OnInit {
  public currentUser: UserDto;
  public allowedAccessEstimationModule: boolean;
  public initCompleted: boolean;
  public isEstimateListRestricted = false;

  public constructor(
    private userService: UserService,
    private licenseService: LicenseService,
    private loadingService: LoadingService,
    private settingsService: EstimateSettingsService
  ) {
    super();
  }

  public async ngOnInit() {
    await this.loadingService.run(async () => {
      this.allowedAccessEstimationModule = await firstValueFrom(
        this.licenseService.isUserAllowedToAccessModule(LicenseAppModule.Estimation)
      );
      this.currentUser = await this.userService.getUserAsync();
      this.initCompleted = true;
      this.isEstimateListRestricted = await this.settingsService.getRestrictEstimateListAccess();
    });

    this.whenDestructing(() => {
      this.loadingService.setIsLoading(false); // the userService will navigate and somehow stop the task without thowing
    });
  }
}
